import PageTitle from "../MainContents/PageTitle/PageTitle";
import styled from 'styled-components';
const Main =styled.div`
    margin-top: 100px;
    width: 90%;
    margin: auto;

`

const Policy: React.VFC = () => {
  return (
    <Main>
      <PageTitle title={'プライバシーポリシー'} englishText={'Privacy&Policy'} />
      <p>
                土佐塾（以下「当社」）は、以下のとおり個人情報保護に関するコンプライアンスプログラムを策定し、
                個人情報保護の仕組みを構築し、全教職員に個人情報保護の重要性の認識と取組みを徹底させることにより、個人情報の保護を推進致します。
            </p>
            <div>
            <div className="mt-3">
                    <h4 className="font-bold">１．個人情報の管理</h4>
                    <p>当社は、お客さまの個人情報を正確かつ最新の状態に保ち、個人情報への不正アクセス・紛失・破損・改ざん・漏洩などを防止するため、セキュリティシステムの維持・管理体制の整備・社員教育の徹底等の必要な措置を講じ、安全対策を実施し個人情報の厳重な管理を行います。</p>
            </div>
            <div className="mt-3">
                    <h4 className="font-bold">２．個人情報の利用目的</h4>
                    <p>お客さまからお預かりした個人情報は、当社からのご連絡や業務のご案内や ご質問に対する回答として、電子メールや資料のご送付に利用いたします。</p>
            </div>
            <div className="mt-3">
                    <h4 className="font-bold">３．個人情報の第三者への開示・提供の禁止</h4>
                    <p>当社は、お客さまよりお預かりした個人情報を適切に管理し、 次のいずれかに該当する場合を除き、個人情報を第三者に開示いたしません。</p>
                    <ul className="list-ul">
                            <li>お客さまの同意がある場合</li>
                            <li>お客さまが希望されるサービスを行うために当社が業務を委託する業者に対して開示する場合</li>
                            <li>法令に基づき開示することが必要である場合</li>
                    </ul>
            </div>
            <div className="mt-3">
                    <h4 className="font-bold">４．個人情報の安全対策</h4>
                    <p>当社は、個人情報の正確性及び安全性確保のために、 セキュリティに万全の対策を講じています。</p>
            </div>
            <div className="mt-3">
                    <h4 className="font-bold">５．ご本人の照会</h4>
                    <p>お客さまがご本人の個人情報の照会・修正・削除などを ご希望される場合には、ご本人であることを確認の上、対応させていただきます。</p>
            </div>
            <div className="mt-3">
                    <h4 className="font-bold">６．法令、規範の遵守と見直し</h4>
                    <p>当社は、保有する個人情報に関して適用される日本の法令、 その他規範を遵守するとともに、本ポリシーの内容を適宜見直し、その改善に努めます。</p>
            </div>
    </div>
    </Main>
    
  );
}
export default Policy;